import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  Grid,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import { PmiButton } from 'shell/components/shared/button';
import { styled } from '@mui/styles';
import { useFormik } from 'formik';
import PmiTextField from 'shell/components/shared/text-field';
import * as yup from 'yup';
import { ParameterItemVM } from './parameter-table';

const validationSchema = yup.object({});

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '50rem',
        maxWidth: '800px',
      },
}));

interface ModalInsertParameterDataProps {
  modalData: ParameterItemVM | null;
  open: boolean;
  jobName?: string;
  disabled?: boolean;
  onClose: (open: boolean) => void;
  onSubmit: (values: ParameterItemVM) => void;
}

const ModalInsertParameterData = ({
  modalData,
  open,
  onClose,
  jobName,
  onSubmit,
  disabled,
}: ModalInsertParameterDataProps): React.ReactElement => {
  const form = useFormik({
    initialValues: modalData || {
      code: '',
      name: '',
      description: '',
      value: '',
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      onSubmit(values);
      resetForm({
        values: {
          code: '',
          name: '',
          description: '',
          value: '',
        },
      });
    },
  });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      fullScreen={fullScreen}
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="primary" color="white">
        Parametro Job
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={7}>
            <PmiTextField
              id="code"
              label="Codice"
              aria-label="Codice"
              fullWidth
              disabled
              value={jobName || ''}
            />
          </Grid>

          <Grid item xs={12}>
            <PmiTextField
              id="name"
              label="Nome"
              aria-label="Nome"
              fullWidth
              disabled={disabled}
              value={form.values?.name || ''}
              onChange={(event) => form.setFieldValue('name', event.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <PmiTextField
              id="description"
              label="Descrizione"
              aria-label="Descrizione"
              fullWidth
              disabled={disabled}
              value={form.values?.description || ''}
              onChange={(event) => form.setFieldValue('description', event.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <PmiTextField
              id="value"
              label="Valore"
              aria-label="Valore"
              fullWidth
              disabled={disabled}
              value={form.values?.value || ''}
              onChange={(event) => form.setFieldValue('value', event.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <PmiButton
          variant="contained"
          color="primary"
          type="submit"
          disabled={disabled}
          onClick={() => {
            form.handleSubmit();
          }}
        >
          CONFERMA
        </PmiButton>
        <PmiButton variant="outlined" color="cdmBrand" type="button" onClick={() => onClose(false)}>
          ANNULLA
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalInsertParameterData.displayName = 'Modal insert parameter data';

export default ModalInsertParameterData;
